import { useMutation } from '@tanstack/react-query';

import { ViewOrderApi } from '../api/viewOrderApi';

interface Props {
  orderId: number;
  orderItemId: string;
  fileName: string;
}

export const useDownloadAllOrderItemData = () => {
  return useMutation({
    mutationFn: async ({ orderId, orderItemId, fileName }: Props) => {
      return await ViewOrderApi.downloadAllOrderItemData(
        orderId,
        orderItemId,
        fileName,
      );
    },
  });
};
